var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59716 9.17694L15.0991 0.703383C15.4893 0.314489 16.1205 0.31436 16.5109 0.703095C16.9034 1.09392 16.9035 1.72926 16.5112 2.12022L8.00893 10.5931C7.22845 11.3709 5.96588 11.3709 5.1854 10.5931L0.932945 6.35532C0.540859 5.96459 0.540859 5.32965 0.932946 4.93891C1.32312 4.55008 1.95429 4.55009 2.34447 4.93891L6.59716 9.17694Z",
    fill: "#37B54A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b027c5f2d871fc6804cf5e4b2890871a.svg";
export { ForwardRef as ReactComponent };